<template>
    <label :for="refId" id="label" class="base-button">
        <base-btn @click="handleClick" :type="toRemove ? 'danger': 'secondary'">
            {{ text }}
        </base-btn>
    </label>
</template>

<script>
export default {
    name: 'LabelBtn',
    props: {
        text: {
            type: String,
            required: true,
        },
        refId: {
            type: String,
            required: true,
        },
        toRemove: {
            type: Boolean,
            required: false,
        },
        handleRemove: {
            type: Function,
            required: false,
        }
    },
    methods: {
        clickInput() {
            document.getElementById('label').click()
        },

        handleClick() {
           if(this.toRemove) {
            this.handleRemove()
           } else {
            this.clickInput()
           }
        }
    }
}
</script>